export const ATTENDEE_CALENDAR_DATE_PARAM = "calendarDate";

type AttendeeNavigationInput = {
  earliestSessionDate?: string | null;
  sessionDateCount?: number | null;
  fallbackDate?: string | null;
};

export const getAttendeeNavigationDates = ({
  earliestSessionDate,
  sessionDateCount,
  fallbackDate,
}: AttendeeNavigationInput) => {
  const calendarDate = earliestSessionDate ?? fallbackDate ?? null;

  return {
    calendarDate,
    sessionDate:
      sessionDateCount === 1 && calendarDate ? calendarDate : ("all" as const),
  };
};

export const getAttendeeCalendarTargetDate = (
  calendarDate: string | null,
  sessionDate: string | null,
) => calendarDate ?? (sessionDate !== "all" ? sessionDate : null);

export const parseCalendarMonth = (value: string | null) => {
  const dateValue = value?.slice(0, 10);
  if (!dateValue || !/^\d{4}-\d{2}-\d{2}$/.test(dateValue)) return null;

  const date = new Date(`${dateValue}T00:00:00.000Z`);
  if (
    Number.isNaN(date.getTime()) ||
    date.toISOString().slice(0, 10) !== dateValue
  ) {
    return null;
  }

  return {
    month: date.getUTCMonth(),
    year: date.getUTCFullYear(),
  };
};
